import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'

type Name = string | null

export interface IdeationListItemProps {
  className?: string
  name: Name
  selectedName: Name
  onSelect: (name: Name) => void
}

const IdeationListItem: FunctionalComponent<IdeationListItemProps> = ({
  className,
  name,
  selectedName,
  onSelect
}) => (
  <li
    className={classnames(className, {
      selected: selectedName === name
    })}
    onClick={() => onSelect(name)}
    onKeyUp={(e) => (e.code === 'Enter' ? onSelect(name) : null)}
    role='button'
    tabIndex={0}
  >
    <div className='vertical-line' />
    {name === null ? <Phrase p='all.statuses' /> : <span>{name}</span>}
  </li>
)

export default IdeationListItem
